import { apiClient } from "@/lib/api-client";

export interface RoleSummary {
	id: string;
	name: string;
	description: string | null;
	permissions: string[];
}

export interface AdminUserRoleAssignment {
	user: { id: string; phone: string | null };
	roles: { id: string; name: string }[];
	permissions: string[];
}

export async function listRoles(): Promise<RoleSummary[]> {
	const response = await apiClient.get("/api/v1/admin/roles");
	return response.data.data.roles as RoleSummary[];
}

/** Null when the user id does not resolve to a user. */
export async function getUserRoles(
	userId: string,
): Promise<AdminUserRoleAssignment | null> {
	const response = await apiClient.get(`/api/v1/admin/users/${userId}/roles`);
	return response.data.data as AdminUserRoleAssignment | null;
}

export async function grantRole(
	userId: string,
	roleId: string,
	reason?: string,
): Promise<void> {
	const trimmed = reason?.trim();
	await apiClient.post(`/api/v1/admin/users/${userId}/roles`, {
		roleId,
		...(trimmed ? { reason: trimmed } : {}),
	});
}

export async function revokeRole(
	userId: string,
	roleId: string,
	reason?: string,
): Promise<void> {
	const trimmed = reason?.trim();
	await apiClient.delete(`/api/v1/admin/users/${userId}/roles/${roleId}`, {
		data: trimmed ? { reason: trimmed } : undefined,
	});
}
